import instance from '@/api/business'
import { ConferenceHub, PropsConferenceHub, ParameterConferenceHub, PropsCreateParameterConferenceHub, PropsUpdateParameterConferenceHub, PropsDeleteParameterConferenceHub } from './type'  

export const fetchConferenceHub = async ({initialDate, finalDate,}: PropsConferenceHub) => {
    const response = await instance.post<ConferenceHub[]>('/processhub/cockpit/processhub/conferencehub',
        {
            initialDate, 
            finalDate 
        }
    ) 
    return response.data
} 
 

export const fetchParameterConferenceHub = async () => {
    const response = await instance.post<ParameterConferenceHub[]>('/processhub/cockpit/processhub/parameterconferencehub') 

    return response.data
} 

export const createParameterConferenceHub = async (Props : PropsCreateParameterConferenceHub) => {
    const response = await instance.put('/processhub/cockpit/processhub/parameterconferencehub', {
        ...Props
    })

    return response.data
}

export const updateParameterConferenceHub = async (Props : PropsUpdateParameterConferenceHub) => {
    const response = await instance.patch('/processhub/cockpit/processhub/parameterconferencehub', {
        ...Props
    })

    return response.data
}

export const deleteParameterConferenceHub = async (Props: PropsDeleteParameterConferenceHub) => {
    const response = await instance.delete('/processhub/cockpit/processhub/parameterconferencehub', {
        data: Props
    })

    return response.data
}